var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dropdown",class:[
		'header-company',
		{ 'active' : _vm.isOpen }
	]},[_c('DropdownButton',{on:{"toggle":_vm.toggleDropdown}},[_vm._t("button")],2),_c('transition',{attrs:{"name":"dropdown-slide"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"header-company-list"},[_vm._t("no-click-list"),_vm._t("list")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }